<header class="header">
  <a routerLink="/" class="header-brand" *ngIf="urlParamsService.params.mobileNavigation">
    <img src="assets/autentique-logo.svg" alt="" />
  </a>
  <div class="header__title" (click)="toggleTitle()" [attr.size]="mainTitle?.length" *ngIf="urlParamsService.params.mobileNavigation">{{ mainTitle }}</div>
  @if (!urlParamsService.params.mobileNavigation) {
    <div class="header__title--whitelabel" [attr.size]="mainTitle?.length">{{ mainTitle }}</div>
    @if (currentUser?.currentPermissions.create_documents) {
      <button type="button" routerLink="/documentos/novo" class="btn-M btn-filled enterpriseBtn">
        {{ 'menu.createDocument' | translate }}
      </button>
    }
  }
  <input id="header__menu--checkbox" type="checkbox" class="header__menu--checkbox" />
  <a routerLink="{{ [menulink] }}" for="header__menu--checkbox" class="header__menu--toggle" *ngIf="urlParamsService.params.mobileNavigation"
    ><svg xmlns="http://www.w3.org/2000/svg" class="icon" width="100" height="100" viewBox="0 0 24 24" stroke-width="2" stroke="#1768E1" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <g transform="translate(1 1)">
        <line class="a" x2="30" transform="translate(0 10)" />
        <line class="a" x2="30" />
        <line class="a" x2="30" transform="translate(0 20)" />
      </g>
    </svg>
  </a>
</header>
